import { z } from 'zod';
export const Auth0ZoneTypeSchema = z.enum(['csr', 'delegate', 'sms', 'tplap']);
export const auth0ZoneType = Auth0ZoneTypeSchema.enum;
export const DeprecatedAuth0ZoneTypeSchema = z.enum(['estimator', 'external-estimator']);
export const Auth0ZoneSchema = z.object({
    domain: z.string(),
    connection: z.string(),
    clientId: z.string(),
    orgId: z.string(),
    type: Auth0ZoneTypeSchema,
    createPassword: z.boolean(),
    sendWelcomeEmail: z.boolean(),
    sendInviteEmail: z.boolean(),
});
